// extracted by mini-css-extract-plugin
module.exports = {"documents":"DocumentSources_documents__2xLWS","footerContainer":"DocumentSources_footerContainer__2Set-"};